import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import Reveal from "../../motion/Reveal";

const items = [
  ["Where is the hospital?", "Near Rockford School, Anaj Mandi Chowk, Kadipur Road, Shakti Park, Sector 10A, Gurugram, Haryana."],
  ["What are OPD hours?", "Monday to Sunday, 9:00 AM to 5:00 PM. The published respiratory clinic with Dr Arun Chowdary Kotaru is Sunday, 10:00 AM to 1:00 PM. Call the same day before you come."],
  ["Can I book on the website?", "No. There is no contact form and no online appointment. Call 98185 48492 or 70423 28047, or walk in during OPD hours."],
  ["Do you have beds?", "Yes. The trust describes the hospital as 25-bedded, with a general ward and private rooms."],
  ["How do lab tests work?", "Samples are collected at the hospital or at home. Reports are done by NABL / ISO certified partner labs. For collection, call 85859 66266 or 98185 48492."],
  ["Is this an emergency department?", "Call the hospital for urgent advice. If someone is unconscious, struggling to breathe, has chest pain, a seizure, or heavy bleeding, do not wait on a website — use the nearest emergency service as well."],
];

const Faq = () => {
  const [open, setOpen] = useState(0);
  const reduce = useReducedMotion();

  return (
    <section className="section faq" id="faq">
      <div className="wrap faq-layout">
        <Reveal>
          <p className="kicker">
            <span>06</span> Questions
          </p>
          <h2>Before you leave the house.</h2>
          <p className="faq-note">
            Hours, beds, and the laboratory. If the answer is “it depends”, the desk will know for today.
          </p>
        </Reveal>
        <div className="faq-list">
          {items.map(([q, a], index) => {
            const isOpen = open === index;
            return (
              <div className={isOpen ? "faq-item open" : "faq-item"} key={q}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : index)}
                >
                  <span>{q}</span>
                  <i aria-hidden="true">{isOpen ? "–" : "+"}</i>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="faq-panel"
                      initial={reduce ? false : { height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={reduce ? undefined : { height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <p>{a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
